import { createContext, useContext, useSyncExternalStore } from 'react';
import type { RuntimeConfig } from '../../config';
import type { StripeBridge } from '../../payments/stripe';
import type { GiftcardController, GiftcardState } from '../../state/giftcard';

export interface GiftEnv {
  controller: GiftcardController;
  config: RuntimeConfig;
  stripe: StripeBridge;
}

export const GiftContext = createContext<GiftEnv | null>(null);

export function useGiftEnv(): GiftEnv {
  const env = useContext(GiftContext);
  if (!env) throw new Error('GiftContext missing');
  return env;
}

export function useGiftState(): GiftcardState {
  const { controller } = useGiftEnv();
  return useSyncExternalStore(controller.subscribe, controller.getState, controller.getState);
}
